module.exports = __webpack_public_path__ + "static/TranslatorInExtension@3x-a161f50d6007c57b27a0ca7a580352da.png";